<div class="container mx-auto px-4 py-6" *transloco="let t">

  <div class="p-6 w-full max-w-7xl mx-auto bg-white shadow-md rounded-lg">
    <h2 class="text-2xl font-bold mb-4 text-gray-700">{{ t('productGroup.createTitle') }}</h2>

    <!-- Nome do Grupo -->
    <div class="mb-6">
      <label for="groupName" class="block text-sm font-medium text-gray-700 mb-2">{{ t('productGroup.groupName') }}</label>
      <input type="text" id="groupName" [maxlength]="100" [(ngModel)]="groupName" #groupNameInput="ngModel" required class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" [placeholder]="t('productGroup.groupNamePlaceholder')">

      <!-- Exibe a mensagem de erro se o nome for inválido -->
      <div *ngIf="groupNameInput.invalid && (groupNameInput.touched || formSubmitted)" class="text-red-600 text-sm mt-1">
        {{ t('productGroup.nameRequired') }}
      </div>
    </div>

    <!-- Combo para Selecionar Produtos com Autocomplete -->
    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('productGroup.selectProduct') }}</label>
      <ng-select [(ngModel)]="selectedProduct"
                 [items]="products"
                 bindLabel="title"
                 [placeholder]="t('productGroup.filterProductsPlaceholder')"
                 [typeahead]="productTypeahead$"
                 [searchable]="true"
                 [multiple]="true"
                 class="ng-select w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      </ng-select>

      <!-- Adiciona margem ao botão para evitar sobreposição -->
      <button (click)="addProduct()" class="mt-3 w-full px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">{{ t('productGroup.addProduct') }}</button>
    </div>

    <!-- Grid de Produtos Adicionados -->
    <div class="mb-6">
      <h3 class="text-lg font-medium text-gray-700 mb-3">{{ t('productGroup.selectedProducts') }}</h3>
      <table class="min-w-full bg-white border border-gray-300 rounded-lg">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ t('productGroup.colProduct') }}</th>
            <th class="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr *ngFor="let product of selectedProducts">
            <td class="px-6 py-4 text-sm text-gray-900">{{ product.productId }}</td>
            <td class="px-6 py-4 text-sm text-gray-900">{{ product.title }}</td>
            <td class="px-6 py-4 text-right">
              <button (click)="removeProduct(product)" class="text-red-600 hover:text-red-900">{{ t('productGroup.remove') }}</button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Exibe a mensagem de erro se não houver produtos selecionados -->
      <div *ngIf="!selectedProducts.length && formSubmitted" class="text-red-600 text-sm mt-1">
        {{ t('productGroup.atLeastOneProduct') }}
      </div>
    </div>

    <!-- Botão de Salvar -->
    <div class="mt-6 flex justify-end space-x-4">

      <button (click)="save()" class="w-32 h-10 bg-green-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
        {{ t('common.save') }}
      </button>
      <button (click)="cancelar()" class="w-32 h-10 bg-gray-600 text-white rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
        {{ t('common.cancel') }}
      </button>
    </div>
  </div>
</div>
